import { useEffect } from 'react';
import { useLibertyPage, useReveal } from '@/shared/components/liberty';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { NewsSection } from './components/NewsSection';
import { SystemsSection } from './components/SystemsSection';
import { RankingSection } from './components/RankingSection';
import { WarSection } from './components/WarSection';
import { StreamersSection } from './components/StreamersSection';
import { CtaWide } from './components/CtaWide';
import { SiteFooter } from './components/SiteFooter';
import { Ornament } from './components/SectionTitle';

export default function HomePage() {
  useLibertyPage('site-page');   // titulo = BRAND_NAME ("Cabal Liberty EP39")
  useReveal();

  // Vindo de outra pagina com ancora (/#guerra do painel, rodape do cadastro): o
  // router nao rola sozinho ate o hash.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) document.getElementById(id)?.scrollIntoView();
  }, []);

  return (
    <>
      <SiteHeader />
      <main>
        <Hero />
        <div className="content-surface">
          <NewsSection />
          <Ornament />
          <SystemsSection />
          <Ornament />
          <RankingSection />
          <Ornament />
          <WarSection />
          <StreamersSection />
          <CtaWide />
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
